import { Disclaimer } from '../../common/types/disclaimer.model';

export type Characteristics = {
  value: number | null;
  date: string;
  title: string;
  benchmarkValue: number | null;
  rank: string;
  valueFormat?: string;
  tooltip: string;
};

export type CharacteristicsData = {
  benchmarkName?: string | null;
  asOfDate?: string;
  portfolioCharacteristics?: Characteristics[];
  productName?: string;
  disclaimers?: Disclaimer[];
};

export type CharacteristicsWithRank = Characteristics & { rank: number };

export enum ValueFormat {
  date = 'date',
  percentage = 'percentage',
  currency = 'USD',
  years = 'years',
}
